export const round2Decimals = num =>
  Math.round((num + Number.EPSILON) * 100) / 100;
